import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface Admin {
  id: number;
  name: string;
  username: string;
  email: string;
  phone_number?: string;
  is_active: boolean;
}

interface NavbarProps {
  admin: Admin | null;
  onToggleSidebar: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ admin, onToggleSidebar }) => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
  };

  const handleChangePassword = () => {
    navigate('/change-password');
  };

  return (
    <div className="navbar-header">
        <div className="d-flex">
          {/* Hamburger Menu Button for Mobile */}
          <button
            type="button"
            className="btn header-item waves-effect d-lg-none"
            onClick={onToggleSidebar}
            style={{
              marginRight: '1rem',
              border: 'none',
              background: 'transparent',
              fontSize: '24px',
              color: '#006175',
              padding: '0.5rem'
            }}
            aria-label="Toggle sidebar"
          >
            <i className="bx bx-menu"></i>
          </button>
        </div>

      <div className="d-flex">

        {/* User Profile Dropdown */}
        <div className="dropdown d-inline-block">
          <button
            type="button"
            className="btn header-item waves-effect"
            id="page-header-user-dropdown"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
              <img
                className="rounded-circle header-profile-user"
                src="/assets/images/colored_logo.png"
                alt="Header Avatar"
                style={{ width: '32px', height: '32px', objectFit: 'contain' }}
              />
            <span className="d-none d-xl-inline-block ms-1" key="t-henry">
              {admin?.name || 'Admin'}
            </span>
            <i className="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </button>
          <div className="dropdown-menu dropdown-menu-end">
            <button className="dropdown-item" type="button" onClick={handleChangePassword}>
              <i className="bx bx-lock-alt font-size-16 align-middle me-1"></i>
              <span key="t-change-password">Change Password</span>
            </button>
            <div className="dropdown-divider"></div>
            <button
              className="dropdown-item text-danger"
              onClick={handleLogout}
              type="button"
            >
              <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>
              <span key="t-logout">Logout</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
